module.exports = __webpack_public_path__ + "img/slider_3.c3706ef9.jpg";